/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const SettingsLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M2 12q0-1.3.32-2.5a3 3 0 0 0 2.67-4.63 10 10 0 0 1 4.34-2.5 3 3 0 0 0 5.34 0 10 10 0 0 1 4.34 2.5 3 3 0 0 0 2.67 4.63 10 10 0 0 1 0 5 3 3 0 0 0-2.67 4.63 10 10 0 0 1-4.34 2.5 3 3 0 0 0-5.34 0 10 10 0 0 1-4.34-2.5 3 3 0 0 0-2.67-4.63Q2 13.3 2 12m4.8 3a5 5 0 0 1 .57 3.52q.6.45 1.3.75a5 5 0 0 1 6.67 0q.67-.3 1.3-.75a5 5 0 0 1 3.33-5.77 8 8 0 0 0 0-1.5 5 5 0 0 1-3.34-5.77 8 8 0 0 0-1.3-.75 5 5 0 0 1-6.67 0q-.67.3-1.3.75a5 5 0 0 1-3.33 5.77 8 8 0 0 0 0 1.5A5 5 0 0 1 6.8 15m5.2 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </Icon>
);
